import React from 'react';
import PropTypes from 'prop-types';

import Button, { ButtonGroup } from '../../library/button/button';

import './confirmation.scss';

function Confirmation(props) {
  const {
    confirmLabel = 'Yes, Delete ',
    declineLabel = 'No, Keep',
    handleConfirm,
    handleDecline,
    layout = 'horizontal',
    hasOverlay
  } = props;

  return (
    <div
      className="confirmation"
      styleName={hasOverlay ? 'confirmation-overlay' : ''}
    >
      <div className="confirmation__button-group">
        <ButtonGroup layout={layout}>
          <Button isPrimary onClick={handleConfirm}>
            {confirmLabel}
          </Button>
          <Button isSecondary onClick={handleDecline}>
            {declineLabel}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
}

Confirmation.propTypes = {
  confirmLabel: PropTypes.string,
  declineLabel: PropTypes.string,
  handleConfirm: PropTypes.func,
  handleDecline: PropTypes.func,
  hasOverlay: PropTypes.bool,
  layout: PropTypes.oneOf(['vertical', 'horizontal'])
};

export default Confirmation;
